// <Leaderboard> — the cross-session 排行榜 overlay (#leaderboard). The classic async
// showLeaderboard() fetches /api/leaderboard?n=15, stashes the rows on app.leaderboard, then
// mounts this component (PURE function of `app`) — Preact DIFFS instead of clobbering. Emits
// the SAME class names + data-action="close-leaderboard" + the 排行榜 title so document-level
// click delegation + the smoke grep contract stay green. See PREACT-MIGRATION.md.
import { html, cx, OverlaySheet, Banner, rankBadge, t } from '../shared.js';

// Mirror of the classic per-entry bits builder (games/wins + optional MVP/卧底赢/神探/冤种 tags).
function bits(e: LeaderboardEntry): string {
  const b: string[] = [t('leaderboard.games', { n: e.games }), t('leaderboard.wins', { n: e.wins })];
  if (e.mvp) b.push(t('leaderboard.mvp', { n: e.mvp }));
  if (e.undercoverWins) b.push(t('leaderboard.ucWins', { n: e.undercoverWins }));
  if (e.correctVotes) b.push(t('leaderboard.sleuth', { n: e.correctVotes }));
  if (e.wrongVotes) b.push(t('leaderboard.misfire', { n: e.wrongVotes }));
  return b.join(' · ');
}

export function Leaderboard({ app }: { app: AppState }) {
  // ONE ranking: humans and agents compete on the same board (Tianyu, 2026-09-23) — 🤖/🧑 marks which is which.
  const lb: LeaderboardEntry[] = (app && app.leaderboard) || [];
  // The public board is a live weekly/monthly competition (all-time lives in <Me>). Default weekly.
  const period: 'week' | 'month' = (app && app.lbPeriod === 'month') ? 'month' : 'week';
  const tab = (p: 'week' | 'month') => html`<button class=${cx('lb-tab', p === period && 'on')} data-action="lb-period" data-period=${p}>${t('leaderboard.tab.' + p)}</button>`;
  return html`<${OverlaySheet} close="close-leaderboard">
      <${Banner} title=${t('leaderboard.title')} sub=${t('leaderboard.sub.' + period)} size="clamp(30px,9vw,52px)" />
      <div class="lb-tabs">${tab('week')}${tab('month')}</div>
      <div class="scoreboard">
        ${lb.length
          ? lb.map((e: LeaderboardEntry, i: number) => html`
            <div class="score-row" key=${(e.name || '') + '|' + (e.tag || '') + '|' + i}>
              <div class="rank">${rankBadge(i)}</div>
              <div><b>${(e as any).kind === 'agent' ? '🤖 ' : '🧑 '}${e.name}${e.tag ? html`<span class="lb-tag">#${e.tag}</span>` : ''}</b> <span class="role civ">${e.title}</span><div class="breakdown">${bits(e)}</div></div>
              <div class="score-val">${e.points}</div>
            </div>`)
          : html`<div class="muted" style="text-align:center;font-weight:800;padding:18px">${t('leaderboard.empty.' + period)}</div>`}
      </div>
    </${OverlaySheet}>
  `;
}
